var React = require('react');

function IconThumbdownO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M621.6 636.1H878c44.7 0 81.3-36.6 81.3-81.3v-81.3c0-10.6-2-20.3-5.7-29.7L830.9 157.3c-12.2-29.3-41.1-49.6-74.8-49.6H390.3c-44.7 0-81.3 36.6-81.3 81.3v406.5c0 22.4 8.9 42.7 24 57.3l267.5 267.9 43.1-42.7c11-11 17.9-26.4 17.9-43.1l-1.2-13-38.7-185.8zm-20.5 200.8L375.2 610.6l-.6-.6c-3.8-3.7-5.9-8.7-5.9-14.6V189c0-11.8 9.9-21.7 21.7-21.7h365.8c8.9 0 16.5 5.1 20 13.4l122 284.8.7 1.8-.7-1.8c1.1 2.9 1.6 5.3 1.6 7.9v81.3c0 11.8-9.9 21.7-21.7 21.7H548.3l14.9 71.7M65.1 107.7v487.8h162.6V107.7H65.1zm0 59.6h162.6l-59.6-59.6v487.8l59.6-59.6H65.1l59.6 59.6V107.7l-59.6 59.6z"}));
}

IconThumbdownO.displayName = "IconThumbdownO";

IconThumbdownO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconThumbdownO;

IconThumbdownO.default = IconThumbdownO;
